import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { PieChartConfig } from '../../../../../shared/google-chart/Models/PieChartConfig';

@Component({
	selector: 'app-missed-daily-connection-alert',
	templateUrl: './missed-daily-connection-alert.component.html',
	styleUrls: ['./missed-daily-connection-alert.component.css']
})
export class MissedDailyConnectionAlertComponent implements OnInit, OnChanges {

	@Input() data: any;
	@Input() siteId: number = 0;
	@Input() customerId: number = 0;
	@Input() customerName: string = '';
	@Input() siteName: string = '';

	config: PieChartConfig;
	tableColumns: any[] = [];
	title: string = 'Total Daily Idle After Event Times';
	elementId: string = 'missed_daily_connection';
	widgetClass: string = 'height-530';
	siteWidgetOptions: any = {
		hasDate: true,
		isAlertWidget: true
	};

	constructor() { }

	ngOnInit() {
	
		this.config = new PieChartConfig({
			colors: [
				{ color: '#109618' }, //green
				{ color: '#FFFD38' }, // light yellow
				{ color: '#FED631' }, // dark yellow
				{ color: '#FDA428' }, // orange
				{ color: '#FC471E' }, // light red
				{ color: '#BD2F26' }, // red
			]
		});
		
		this.config.formatFunction = (data) => {
			let formattedData: any[] = [
				[
					{"label": "Name", "type": "string"},
					{"label": "Value", "type": "number"}
				]
			];

			for (var item of data.list) {
				formattedData.push([{v: item.Text}, {v: item.value}]);
			}
			return formattedData;
		};
	}
	
	ngOnChanges(changes) {
		if(this.data) {
			let tableColumns = [{title: "Battery ID", property: "battery_id"}];
			if (this.data.siteSettings.userSettings.view_truck_id) {
				tableColumns.push({title: "Truck ID", property: "truck_id"});
			}
			tableColumns.push({title: "Total Daily Idle After Event Times", property: "value"});
			this.tableColumns = tableColumns;
		}
	}
}
